import { Link } from 'react-router-dom'

const IntroPage = () => (
   <div className="gx-page-error-container">
      <div className="gx-page-error-content">
         <div className="gx-error-code gx-mb-4">Xin chào</div>
         <h2 className="gx-text-center">Chào mừng bạn đến với Zenith!</h2>
         <form className="gx-mb-4" role="search">
            <div className="gx-search-bar">
               <div className="gx-form-group">
                  <button className="gx-search-icon">
                     <i className="icon icon-search" />
                  </button>
               </div>
            </div>
         </form>
         {/* <p className="gx-text-center">
                <Link className="gx-btn gx-btn-primary" to="/">
                    Go Home
                </Link>
            </p> */}
      </div>
   </div>
)

export default IntroPage
